import { render, staticRenderFns } from "./ViewExamResults.vue?vue&type=template&id=73cb6bb1"
import script from "./ViewExamResults.vue?vue&type=script&lang=js"
export * from "./ViewExamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports